import ButtonBase from '@mui/material/ButtonBase';
import PropTypes from 'prop-types';
// BASE
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  icon: {
    height: 28,
    width: 28,
    padding: 2,
    borderRadius: 4,
  },
  smallIcon: {
    borderRadius: 4,
    height: 28,
    width: 24,
    padding: 2,
  },
  menu: {
    padding: 0,
    margin: '0 4px',
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.icon.light,
    '&:hover, &:focus-within': {
      color: theme.palette.icon.dark,
    },
  },
  disabled: {
    backgroundColor: 'transparent',
    cursor: 'default',
    '&:hover, &:focus-within': {
      color: theme.palette.icon.light,
    },
  },
}));

const RegisterButton = React.forwardRef((props, ref) => {
  const { classes, cx } = useStyles();

  const { Icon, className, small, iconColor, disabled, tabIndex = -1, ...otherProps } = props;

  return (
    <ButtonBase
      className={cx(classes.menu, disabled ? classes.disabled : undefined, className)}
      focusRipple={!disabled}
      disableRipple={disabled}
      tabIndex={tabIndex}
      disabled={disabled}
      ref={ref}
      {...otherProps}
    >
      <Icon
        className={small ? classes.smallIcon : classes.icon}
        sx={iconColor ? { color: `${iconColor} !important`, opacity: '1 !important' } : undefined}
      />
    </ButtonBase>
  );
});

RegisterButton.propTypes = {
  Icon: PropTypes.any,
  className: PropTypes.string,
  small: PropTypes.bool,
  iconColor: PropTypes.string,
  disabled: PropTypes.bool, // intentionally not using the 'disabled' prop for buttons as it causes tooltip problems
  tabIndex: PropTypes.number, // defaults to -1: register rows/grid cells drive their own keyboard nav
};

RegisterButton.displayName = 'RegisterButton';
export default RegisterButton;
